<template>

    <div class="nav-main d-none d-md-block">
        <a href="/" class="scrollactive-item">← Home</a>
    </div>
</template>

<script>
    export default {
        data: function(){
            return {
            };
        }
    }
</script>


// WEBPACK FOOTER //
// HeaderAlt.vue?734183aa